export default __webpack_public_path__ + "static/download-assets-sm-2-1048f412b8d7b3d65e2b55b84b88d298.svg";